module.exports = __webpack_public_path__ + "assets/media/kv-03aa2076.mp4";